import gql from "graphql-tag";

export const TaskReschedules = gql`
  mutation subtaskReschedulingByClient($input: SubtaskReschedulingByClientInput!) {
    subtaskReschedulingByClient(input: $input) {
      message
      code
      error
    }
  }
`;

export const DeleteSubtaskPickupFromClient = gql`
  mutation deleteSubtaskPickupFromClient($input: DeleteInput!) {
    deleteSubtaskPickupFromClient(input: $input) {
      code
      error
      message
      data
    }
  }
`;